import { styled } from '@mui/material/styles';
import Tabs, { TabsProps } from '@mui/material/Tabs';

const StyledTabs = styled(Tabs)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.faint,
    borderRadius: '9999px',

    '.MuiTabs-flexContainer, .MuiTabs-list': {
        gap: theme.spacing(1),
        margin: theme.spacing(1),
    },

    '.MuiTab-root': {
        border: '1px solid transparent',
        borderRadius: '9999px',
        lineHeight: 1.25,
        minHeight: theme.spacing(5),
        padding: theme.spacing(1, 2),

        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },

        '&:focus-visible': {
            borderColor: theme.palette.primary.main,
            outline: `1px solid ${theme.palette.primary.main}`,
        },

        '&.Mui-selected': {
            backgroundColor: theme.palette.background.paper,
            borderColor: theme.palette.primary.main,
            boxShadow: theme.shadows[2],

            '&:hover': {
                backgroundColor: theme.palette.background.paper,
            },
        },
    },

    '.MuiTabs-indicator': {
        display: 'none',
    },
}));

export const SegmentedTabs: React.FC<TabsProps> = (props) => <StyledTabs {...props} variant="fullWidth" />;

SegmentedTabs.displayName = 'SegmentedTabs';
